<template>
  <div class="register2-content">
    <AlertMessages />
    <form @submit.prevent="createAccount">
      <fieldset>
        <legend class="page-title">Job Information</legend>
      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper" v-flyout>
            <input
              class="text-field-4"
              id="jobTitle"
                      aria-label="Job title"
                      :aria-invalid="$v.JobTitle.$error"
                      aria-errormessage="errorJobTitle"
              v-model="JobTitle"
              @blur="$v.JobTitle.$touch()"
              :class="{ 'is-invalid': $v.JobTitle.$error }"
            />
            <i class="fa fa-check"></i>
            <div class="field-placeholder" v-animate>
              <span class="">Job Title</span>
            </div>
          </div>
          <div id="errorJobTitle" v-if="$v.JobTitle.$error" class="feedback">
            <span v-if="!$v.JobTitle.maxLength"
              >Job title must be less than 100 characters</span
            >
            <span v-if="!$v.JobTitle.characters"
              >Characters and alphabets, hyphens and numbers are allowed</span
            >
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper select-field-4" v-flyout>
            <select
              id="sector"
                      aria-label="Sector"
                      aria-required="true"
                      :aria-invalid="$v.Sector.$error"
                      aria-errormessage="errorSector"
              v-model="Sector"
              @change="onChange($event)"
              :class="{ 'is-invalid': $v.Sector.$error }"
              @blur="$v.Sector.$touch()"
              ><option
                v-for="option in sectors"
                :key="option.value"
                :value="option.value"
                >{{ option.value }}</option
              >
            </select>
            <div class="field-placeholder" v-animate>
              <span class="asterisk">Sector</span>
            </div>
          </div>
          <i
            v-if="!$v.Sector.$error && this.Sector != null"
            class="fa fa-check"
          ></i>
          <div id="errorSector" v-if="$v.Sector.$error" class="feedback">
            <span v-if="!$v.Sector.required">This field is required</span>
          </div>
        </div>
      </div>

      <div v-if="this.Sector === 'Education/School'">
        <div class="form-row">
          <div class="col-12">
            <div class="field-wrapper select-field-4" v-flyout>
              <select
                id="school"
                      aria-label="Type of School/College"
                      aria-required="true"
                      :aria-invalid="$v.TypeOfSchool.$error"
                      aria-errormessage="errorTypeOfSchool"
                v-model="TypeOfSchool"
                @blur="$v.TypeOfSchool.$touch()"
                :class="{ 'is-invalid': $v.TypeOfSchool.$error }"
                ><option
                  v-for="option in schools"
                  :key="option.value"
                  :value="option.value"
                  >{{ option.value }}</option
                >
              </select>

              <div class="field-placeholder" v-animate>
                <span class="asterisk">Type of school/college</span>
              </div>
            </div>
            <i
              v-if="!$v.TypeOfSchool.$error && this.TypeOfSchool != null"
              class="fa fa-check"
            ></i>
            <div id="errorTypeOfSchool" v-if="$v.TypeOfSchool.$error" class="feedback">
              <span v-if="!$v.TypeOfSchool.customValidation"
                >This field is required</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper" v-flyout>
            <input
              class="text-field-4"
              id="organ"
              autocomplete="organization-title"
                      aria-label="School/Organisation name"
                      aria-required="true"
                      :aria-invalid="$v.OrganisationName.$error"
                      aria-errormessage="errorOrganisationName"
              v-model="OrganisationName"
              @blur="$v.OrganisationName.$touch()"
              :class="{ 'is-invalid': $v.OrganisationName.$error }"
            />
            <i class="fa fa-check"></i>
            <div class="field-placeholder" v-animate>
              <span class="asterisk">School/Organisation name</span>
            </div>
          </div>
          <div id="errorOrganisationName" v-if="$v.OrganisationName.$error" class="feedback">
            <span v-if="!$v.OrganisationName.required"
              >This field is required</span
            >
            <span v-if="!$v.OrganisationName.maxLength"
              >School/Organisation name must be less than 100 characters</span
            >
            <span v-if="!$v.OrganisationName.characters"
              >Characters and alphabets, hyphens and numbers are allowed</span
            >
          </div>
        </div>
      </div>
      </fieldset>
      <fieldset>
        <legend class="page-title">Address Information</legend>
      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper" v-flyout>
            <input
              class="text-field-4"
              id="address1"
              autocomplete="address-line1"
                      aria-label="Address Line 1"
                      :aria-invalid="$v.AddressLine1.$error"
                      aria-errormessage="errorAddressLine1"
              v-model="AddressLine1"
              @blur="$v.AddressLine1.$touch()"
              :class="{ 'is-invalid': $v.AddressLine1.$error }"
            />
            <i class="fa fa-check"></i>
            <div class="field-placeholder" v-animate>
              <span class="">Address line 1</span>
            </div>
          </div>
          <div id="errorAddressLine1" v-if="$v.AddressLine1.$error" class="feedback">
            <span v-if="!$v.AddressLine1.maxLength"
              >Address line 1 must be less than 100 characters</span
            >
            <span v-if="!$v.AddressLine1.characters"
              >Characters and alphabets, hyphens and numbers are allowed</span
            >
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper" v-flyout>
            <input
              class="text-field-4"
              id="address2"
              autocomplete="address-line2"
                      aria-label="Address Line 2"
                      :aria-invalid="$v.AddressLine2.$error"
                      aria-errormessage="errorAddressLine2"
              v-model="AddressLine2"
              @blur="$v.AddressLine2.$touch()"
              :class="{ 'is-invalid': $v.AddressLine2.$error }"
            />
            <i class="fa fa-check"></i>
            <div class="field-placeholder" v-animate>
              <span class="">Address line 2</span>
            </div>
          </div>
          <div id="errorAddressLine2" v-if="$v.AddressLine2.$error" class="feedback">
            <span v-if="!$v.AddressLine2.maxLength"
              >Address line 2 must be less than 100 characters</span
            >
            <span v-if="!$v.AddressLine2.characters"
              >Characters and alphabets, hyphens and numbers are allowed</span
            >
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-12 col-lg-6">
          <div class="field-wrapper" v-flyout>
            <input
              class="text-field-1"
              id="city"
                      aria-label="City"
                      :aria-invalid="$v.City.$error"
                      aria-errormessage="errorCity"
              v-model="City"
              @blur="$v.City.$touch()"
              :class="{ 'is-invalid': $v.City.$error }"
            />
            <i class="fa fa-check"></i>
            <div class="field-placeholder" v-animate>
              <span class="">City</span>
            </div>
          </div>
          <div id="errorCity" v-if="$v.City.$error" class="feedback">
            <span v-if="!$v.City.maxLength"
              >City must be less than 100 characters</span
            >
            <span v-if="!$v.City.characters"
              >Characters and alphabets, hyphens and numbers are allowed</span
            >
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="field-wrapper" v-flyout>
            <input
              class="text-field-1"
              id="postcode"
              autocomplete="postal-code"
                      aria-label="Postcode"
                      :aria-invalid="$v.Postcode.$error"
                      aria-errormessage="errorPostcode"
              v-model="Postcode"
              @blur="$v.Postcode.$touch()"
              :class="{ 'is-invalid': $v.Postcode.$error }"
            />
            <i class="fa fa-check"></i>
            <div class="field-placeholder" v-animate>
              <span class="">Postcode</span>
            </div>
          </div>
          <div id="errorPostcode" v-if="$v.Postcode.$error" class="feedback">
            <span v-if="!$v.Postcode.maxLength"
              >Postcode must be less than 20 characters</span
            >
            <span v-if="!$v.Postcode.characters"
              >Characters and alphabets, hyphens and numbers are allowed</span
            >
          </div>
        </div>
      </div>
      </fieldset>
      <fieldset>
        <legend class="page-title">Other Information</legend>
      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper select-field-4" v-flyout>
            <select
              id="referral"
                      aria-label="How did you hear about us?"
                      aria-required="true"
                      :aria-invalid="$v.HowDidYouHearAboutUs.$error"
                      aria-errormessage="errorHowDidYouHearAboutUs"
              v-model="HowDidYouHearAboutUs"
              @blur="$v.HowDidYouHearAboutUs.$touch()"
              :class="{ 'is-invalid': $v.HowDidYouHearAboutUs.$error }"
              ><option
                v-for="option in referrals"
                :key="option.value"
                :value="option.value"
                >{{ option.value }}</option
              >
            </select>

            <div class="field-placeholder" v-animate>
              <span class="asterisk">How did you hear about us?</span>
            </div>
          </div>
          <i
            v-if="
              !$v.HowDidYouHearAboutUs.$error &&
                this.HowDidYouHearAboutUs != null
            "
            class="fa fa-check"
          ></i>
          <div id="errorHowDidYouHearAboutUs" v-if="$v.HowDidYouHearAboutUs.$error" class="feedback">
            <span v-if="!$v.HowDidYouHearAboutUs.required"
              >This field is required</span
            >
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="keep">
          <p class="keep-title">Keep up to date with NSPCC Learning</p>
          <p class="label-info">
            We would like to keep you informed about our professional training,
            events, latest news, services and resources that may be relevant to
            you. Please let us know whether you’re happy to receive our emails:
          </p>
          <div class="form-row">
            <label class="checkbox checkbox-email label-info" for="emailOptIn"><div>
              Yes I would like to receive emails.
              <input
                type="checkbox"
                class="label-info"
                id="emailOptIn"
                v-model="EmailOptIn"/>

              <span class="checkmark"></span
            ></div></label>
          </div>
        </div>
      </div>

      <div class="form-row">
        <label class="checkbox checkbox-policy label-info" for="policy">
          <div>
            I have read and accepted the
            <a
              target="_blank"
              href="https://www.nspcc.org.uk/terms-conditions/"
              class="active"
            >
              Terms of Use
            </a>
            and
            <a
              target="_blank"
              href="https://www.nspcc.org.uk/privacy-policy/"
              class="active"
            >
              Privacy Policy.</a
            ><span class="asterisk"></span>
          </div>
          
          <input type="checkbox" aria-required="true"
                      :aria-invalid="$v.TermsOfUseAccepted.$error"
                      aria-errormessage="errorTermsOfUseAccepted" id="policy" v-model="TermsOfUseAccepted" />
          <span class="checkmark"></span>
        </label>
        <div id="errorTermsOfUseAccepted" v-if="$v.TermsOfUseAccepted.$error" class="feedback">
          <span v-if="!$v.TermsOfUseAccepted.required"
            >This field is required</span
          >
        </div>
      </div>
    </fieldset>
      <div class="form-row cta-group flex-column-reverse flex-md-row">
        <router-link
          role="navigation"
          class="back-link"
          :to="{ name: 'register' }"
          @click.native="GoToStep1()"
        >
          <span class="angle-left-green"></span>
          Back to account info
        </router-link>
        <!-- <router-link
        class="cta-white-203"
        :to="{ name: 'register' }"
        
      >
        Create account
      </router-link> -->
        <button role="button" class="cta-white-203">
          Create account<span class="angle-right-white"></span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import AlertMessages from "../components/alert-messages";
import { SET_USER } from "../store/mutation-types";

// characters and alphabets, hyphens and numbers only
const characters = helpers.regex(
  "characters",
  /^[0-9a-zA-Z\u00C0-\u024F\u1E02-\u1EF3'\- ]+$/
);

export default {
  name: "RegisterStep2",
  components: { AlertMessages },
  validations: {
    JobTitle: {
      maxLength: maxLength(100),
      characters
    },

    Sector: {
      required
    },
    TypeOfSchool: {
      customValidation(value, vm) {
        if (vm.Sector === "Education/School") {
          return value?.length > 0;
        }
        return true;
      }
    },
    OrganisationName: {
      required,
      maxLength: maxLength(100),
      characters
    },
    AddressLine1: {
      maxLength: maxLength(100),
      characters
    },
    AddressLine2: {
      maxLength: maxLength(100),
      characters
    },
    City: {
      maxLength: maxLength(100),
      characters
    },
    Postcode: {
      maxLength: maxLength(20),
      characters
    },
    HowDidYouHearAboutUs: {
      required
    },
    TermsOfUseAccepted: {
      required(val) {
        return val;
      }
    }
  },
  data() {
    return {
      referrals: [],
      sectors: [],
      schools: []
    };
  },

  async created() {
    await this.getContent();
    if (this.content.Sectors)
      this.sectors = this.content.Sectors.map(x => {
        return { value: x };
      });
    if (this.content.HowDidYouHearAboutUs)
      this.referrals = this.content.HowDidYouHearAboutUs.map(x => {
        return { value: x };
      });
    if (this.content.SchoolTypes)
      this.schools = this.content.SchoolTypes.map(x => {
        return { value: x };
      });
  },
  computed: {
    ...mapGetters("users", ["getUserById"]),
    ...mapState("users", ["user"]),
    ...mapGetters("alert", ["hasError"]),
    ...mapState("util", ["content"]),
    RegistrationStatus: {
      get() {
        return this.user.RegistrationStatus;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { RegistrationStatus: val });
      }
    },
    Id: {
      get() {
        return this.user.Id;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Id: val });
      }
    },
    JobTitle: {
      get() {
        return this.user.JobTitle;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { JobTitle: val });
      }
    },
    TypeOfSchool: {
      get() {
        return this.user.TypeOfSchool;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TypeOfSchool: val });
      }
    },
    Sector: {
      get() {
        return this.user.Sector;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Sector: val });
      }
    },
    OrganisationName: {
      get() {
        return this.user.OrganisationName;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { OrganisationName: val });
      }
    },

    AddressLine1: {
      get() {
        return this.user.AddressLine1;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { AddressLine1: val });
      }
    },
    AddressLine2: {
      get() {
        return this.user.AddressLine2;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { AddressLine2: val });
      }
    },
    City: {
      get() {
        return this.user.City;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { City: val });
      }
    },
    Postcode: {
      get() {
        return this.user.Postcode;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Postcode: val });
      }
    },
    HowDidYouHearAboutUs: {
      get() {
        return this.user.HowDidYouHearAboutUs;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { HowDidYouHearAboutUs: val });
      }
    },
    TermsOfUseAccepted: {
      get() {
        let val = this.user.TermsOfUseAccepted;
        if (val == undefined) val = false;
        return val;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TermsOfUseAccepted: val });
      }
    },
    EmailOptIn: {
      get() {
        let val = this.user.EmailOptIn;
        if (val == undefined) val = false;
        return val;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { EmailOptIn: val });
      }
    }
  },
  methods: {
    ...mapActions("users", ["createUser"]),
    ...mapActions("util", ["getContent"]),
    ...mapActions("alert", ["clear"]),
    onChange(event) {
      this.Sector = event.target.value;
       if (this.Sector !== "Education/School") {
         this.TypeOfSchool =null;
       }
    },
    async createAccount() {
      this.clear();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.RegistrationStatus = 3;
      await this.createUser({
        user: this.user,
        regStatus: this.RegistrationStatus
      });
      if (!this.hasError) {
        this.$emit("setVerification", true);
      }
    },
    GoToStep1() {
      this.$emit("clicked", "0");
    }
  }
};
</script>

<style></style>
